import { render } from "./ChatInput.vue?vue&type=template&id=6fb76c9f&ts=true"
import script from "./ChatInput.vue?vue&type=script&lang=ts"
export * from "./ChatInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/ChatInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fb76c9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fb76c9f', __exports__)) {
    api.reload('6fb76c9f', __exports__)
  }
  
  module.hot.accept("./ChatInput.vue?vue&type=template&id=6fb76c9f&ts=true", () => {
    api.rerender('6fb76c9f', render)
  })

}


export default __exports__